"use client";

import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StillHaveQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="still-have-questions" className="dark bg-background text-foreground py-[100px] px-4 flex justify-center items-center">
      <div ref={ref} className={`max-w-xl mx-auto text-center flex flex-col items-center space-y-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h3 className="text-2xl md:text-3xl font-semibold font-default tracking-tight">
          Can't find what you need?
        </h3>
        <p className="text-muted-foreground font-default text-base md:text-lg max-w-md">
          Our support team is available 24/7 to assist you with any inquiries regarding our digital services and crypto payments.
        </p>
        <div className="pt-4">
          <Button variant="ghost" size="lg" asChild className="text-base">
            <Link to="#">
              <Mail className="w-5 h-5 mr-2" />
              Contact Support
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}